export default __webpack_public_path__ + "static/media/thiencuong.9e47459c.png";